<ng-container>
  <div
    [ngClass]="{
      'disabled-project':
        params.data.recycledCreditId == 1 || params.data.recycledCreditId == 2 ? true : false
    }"
  >
    <ngx-slider
      [options]="options"
      (userChangeEnd)="changeRuralValue($event)"
      [value]="sliderValue"
    ></ngx-slider>
  </div>
</ng-container>
